<template>
    <div class="AI-attendance">
        AI-attendance
            <!-- <div class="pageBox">
                <el-pagination v-if="total_number > page_size" @current-change="change_page" :page-size="page_size" :current-page="page_index" layout="total,prev, pager, next,jumper" :total="total_number">
                </el-pagination>
            </div> -->
        <!-- <div class="dependent" v-if="placeholder">
            <i class="ipng image_state01"></i>
            <p>还没发现任何相关的圈组哦~</p>
        </div> -->
    </div>
</template>
   
<script>
export default {
    data() {
        return {
            page_index: 1,
            page_size: 8,
            total_number: 0,

        };
    },
    created() {
        // this.getGroupList();
    },
    methods: {
  
        // change_page(val) {
        //     this.page_index = val;
        //     this.getGroupList();
        // },
    }
};
</script>
